const header = document.querySelector('header');
const transparentHeader = header.classList.contains('paydesk-header--transparent');
const transparentBlack = ['/media-monitoring', '/monitor'].includes(window.location.pathname);
const navLogo = document.querySelector('.paydesk-nav__logo-img');
const searchInput = header.querySelector('.search-input');
const topNavSearchContainer = header.querySelector('.top-menu-search-container')

const navMenuBurger = header.querySelector('.paydesk-nav__hamburger-icon');
const navMenuBurgerBtn = header.querySelector('.paydesk-nav__hamburger');
const mobileNavTrigger = header.querySelector('.paydesk-mobile-nav-trigger');
const mobileNavClose = header.querySelector('.paydesk-mobile-nav-close');
const mobileNav = header.querySelector('.paydesk-mobile-nav-items');

const setUserMenusOpen = (openIndex) => {
    const popupMenuBtn = document.querySelectorAll('.paydesk-main-nav-user');
    const popupMenuBody = document.querySelectorAll('.menu');
    popupMenuBody.forEach((item, i) => {
        item.classList.toggle('tw-hidden', i !== openIndex);
        popupMenuBtn[i]?.setAttribute('aria-expanded', i === openIndex ? 'true' : 'false');
    });
};

document.body.addEventListener('click', (e) => {
    const clickedBtn = e.target.closest('.paydesk-main-nav-user');
    const clickedMenu = e.target.closest('.menu');
    if (clickedBtn) {
        const popupMenuBtn = document.querySelectorAll('.paydesk-main-nav-user');
        const index = Array.from(popupMenuBtn).indexOf(clickedBtn);
        const isMenuOpen = !document.querySelectorAll('.menu')[index].classList.contains('tw-hidden');
        setUserMenusOpen(isMenuOpen ? -1 : index);
    } else if (!clickedMenu) {
        setUserMenusOpen(-1);
    }
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setUserMenusOpen(-1);
});

const solutionsToggle = header.querySelector('.solutions-toggle');
const solutionsMenu = header.querySelector('.solutions-menu');
if (solutionsToggle && solutionsMenu) {
    const setSolutionsOpen = (open) => {
        solutionsMenu.classList.toggle('tw-hidden', !open);
        solutionsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    solutionsToggle.addEventListener('click', () => {
        setSolutionsOpen(solutionsMenu.classList.contains('tw-hidden'));
    });
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.tw-group') && !solutionsMenu.classList.contains('tw-hidden')) setSolutionsOpen(false);
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setSolutionsOpen(false);
    });
}

let mobileNavOpen = false;
function attachSearchBox(asMobile) {
  let searchContainer = asMobile ? mobileNav : topNavSearchContainer;
  searchInput && searchContainer?.insertBefore(searchInput, searchContainer?.childNodes[0]);
}
topNavSearchContainer && attachSearchBox(!(topNavSearchContainer.offsetParent || topNavSearchContainer.offsetWidth
                  || topNavSearchContainer.offsetHeight));
// re-home the search box on viewport changes (tablet rotation)
topNavSearchContainer && window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => {
    attachSearchBox(!e.matches);
});
function toggleMobileNav() {
  mobileNavOpen = !mobileNavOpen;
  mobileNav.classList.toggle('tw-hidden', !mobileNavOpen);
  navMenuBurger?.setAttribute('icon', mobileNavOpen ? 'ant-design:close-outlined' : 'ci:hamburger-lg');
  navMenuBurgerBtn?.setAttribute('aria-expanded', mobileNavOpen ? 'true' : 'false');
  mobileNavTrigger?.setAttribute('aria-expanded', mobileNavOpen ? 'true' : 'false');
  mobileNavTrigger?.classList.toggle('tw-hidden', mobileNavOpen);
  mobileNavClose?.classList.toggle('tw-hidden', !mobileNavOpen);
  attachSearchBox(mobileNavOpen);
  updateNavState();
}
(navMenuBurgerBtn || navMenuBurger)?.addEventListener('click', toggleMobileNav);
mobileNavTrigger?.addEventListener('click', toggleMobileNav);
mobileNavClose?.addEventListener('click', toggleMobileNav);

const updateNavState = () => {
  if (transparentHeader) {
    const scrolled = window.scrollY > 80 || mobileNavOpen;

    if (transparentBlack) {
        header.classList.remove('paydesk-header--transparent');
        header.style.setProperty('background', scrolled ? 'white': 'transparent', 'important');
    } else {
        header.classList.toggle('paydesk-header--transparent', !scrolled);
    }
    header.classList.toggle('tw-shadow-md', scrolled);

    navLogo.src = (scrolled || transparentBlack) ? '/static/img/brand/journalist_net_logo.svg':
                             '/static/img/brand/svg/paydesk-logo-mono-white-transperent-bg-full.svg';
  }
};
updateNavState();
window.addEventListener('scroll', updateNavState);

// login modal window
const loginForm = document.getElementById('loginForm');
const loginBtn = document.querySelector('.btn-login');
[loginForm, loginBtn].map(item=>item?.addEventListener('click', function () {
    loginForm?.classList.toggle('tw-hidden')
}));
document.querySelector('#loginForm .panel-block')?.addEventListener('click', function (event) {
    event.stopImmediatePropagation();
});

// side menu
const activateSidenav = () => {
    const sidenavMenu = document.getElementById('sidenav-menu');
    const sidenavMenuBtn = document.getElementById('sidenav-menu-btn');
    if (!sidenavMenu || !sidenavMenuBtn) return;

    const activeSidenavText = sidenavMenu.firstElementChild?.querySelectorAll('.active')[0]?.textContent;
    if (activeSidenavText) {
        sidenavMenuBtn.firstChild.nodeValue = activeSidenavText;
    }

    const isOpen = () => !sidenavMenu.classList.contains('tw-hidden');
    const setOpen = (open) => {
        sidenavMenu.classList.toggle('tw-hidden', !open);
        sidenavMenuBtn.classList.toggle('tw-shadow-active', open);
        sidenavMenuBtn.classList.toggle('tw-border-border', !open);
        sidenavMenuBtn.classList.toggle('tw-border-brand-600', open);
        sidenavMenuBtn.children[0].classList.toggle('tw-rotate-[-180deg]', open);
        sidenavMenuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    sidenavMenuBtn.addEventListener('click', () => setOpen(!isOpen()));
    sidenavMenuBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen(!isOpen());
        }
    });

    // close the mobile overlay on outside click, Escape, or resize up to desktop
    document.addEventListener('click', (e) => {
        if (isOpen() && !sidenavMenu.contains(e.target) && !sidenavMenuBtn.contains(e.target)) {
            setOpen(false);
        }
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) setOpen(false);
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => {
        if (e.matches && isOpen()) setOpen(false);
    });
};
activateSidenav();
